import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { GoogleAnalyticsService } from '../../services/google.analytics.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    constructor(updates: SwUpdate, private router: Router) {
        updates.available.subscribe((event) => {
            updates.activateUpdate().then(() => location.reload());
        });

        let wrapper = document.getElementById('imgoingcalendar-wrapper');
        if (wrapper) {
            // adding "data-" to html element, as some CMS would remove other attributes
            let route = wrapper.attributes['route'] || wrapper.attributes['data-route'];
            console.log(route);
            if (route) {
                const url = route.value;
                this.router.navigate([url], { skipLocationChange: true });
            } else {
                alert(
                    'Please specify the default URL for ImGoing in the wrapper element, e.g., <div id="imgoingcalendar-wrapper" data-route="/demo/events"></div>'
                );
            }
        } else {
            // load Google Analytics script
            GoogleAnalyticsService.loadJs('G-0Y0FTMFQZJ');
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/app/app.component.ts